import React from 'react';
import { Sparkles, X } from 'lucide-react';
import {
  getCommentsOpenHelperCopy,
  type CommentsOpenHelperVariant,
} from '../../utils/commentsOpenHelper';
import './CommentsOpenHelper.css';

export interface CommentsOpenHelperProps {
  variant: CommentsOpenHelperVariant;
  onDismiss: () => void;
}

/**
 * Lightweight one-time hint shown inside the comments popout the first time a
 * user opens any comment thread on this device.
 */
const CommentsOpenHelper: React.FC<CommentsOpenHelperProps> = ({ variant, onDismiss }) => {
  const copy = getCommentsOpenHelperCopy(variant);

  return (
    <div
      className={`coh-banner coh-banner--${variant}`}
      role="status"
      aria-live="polite"
      data-comments-open-helper
    >
      <div className="coh-banner-icon" aria-hidden>
        <Sparkles size={14} />
      </div>
      <div className="coh-banner-copy">
        <span className="coh-banner-title">{copy.title}</span>
        <span className="coh-banner-body">{copy.body}</span>
      </div>
      <button
        type="button"
        className="coh-banner-dismiss"
        onClick={onDismiss}
        aria-label="Dismiss tip"
      >
        Got it
      </button>
      <button
        type="button"
        className="coh-banner-close"
        onClick={onDismiss}
        aria-label="Close tip"
      >
        <X size={14} />
      </button>
    </div>
  );
};

export default CommentsOpenHelper;
